import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import DimensionConversion_001 from './img/DimensionConversion_001.jpg'
import DimensionConversion_002 from './img/DimensionConversion_002.png'

export default class DimensionConversion extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">使用经纬线功能</div>
        <div className="main-window-content">点击二三维转换，实现球上二三维转换</div>
        <img src={DimensionConversion_001} className="main-window-img"></img>
        <img src={DimensionConversion_002} className="main-window-img"></img>
      </div>
    )
  }
}
